import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { computeUpdatedFilters } from "helpers/filters"
import { Types as LoaderTypes } from "model/data"
import { NORMALIZATION, removeUnsupportedFilters, removeUnsupportedAddedFilters } from "helpers/segments"
import { Types as PortfolioRootTypes } from "modules/portfolio-root/model"

export const { Types, Creators } = createActions("ompnt/modules/analyzeHeader/", {
  toggleFilters: [],
  setFilter: ["filter", "visibility"],
  setNormalization: {
    props: ["normalization"],
    track: true,
    trackType: "analyze-trends-normalization-selection",
    trackPayload: ({ normalization }) => ({ normalization }),
  },
  updateFilters: {
    props: ["filter"],
    track: true,
    trackType: "analyze-trends-segment-filters-update",
    trackPayload: ({ filter }) => ({ filter }),
  },
})

const INITIAL_STATE = {
  filter: null,
  filtersVisible: false,
  normalization: NORMALIZATION.CONTRIBUTION,
}

function handleToggleFilters(state) {
  return { ...state, filtersVisible: !state.filtersVisible }
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetFilter(state, { filter, visibility }) {
  return { ...state, filter, filtersVisible: visibility }
}

function handleSetNormalization(state, { normalization }) {
  return { ...state, normalization }
}

const handleLoadSuccess = (state, action) => {
  if (action.resource === "portfolio") {
    return INITIAL_STATE
  } else {
    return state
  }
}

const handleSetSelectedBase = (state, { selectedBase }) => {
  const newFilter = removeUnsupportedFilters(state.filter, !!selectedBase, state.normalization)
  const newAddedFilters = removeUnsupportedAddedFilters(state.addedFilters, !!selectedBase, state.normalization)
  return { ...state, filter: newFilter, addedFilters: newAddedFilters }
}

export const HANDLERS = {
  [Types.TOGGLE_FILTERS]: handleToggleFilters,
  [Types.SET_FILTER]: handleSetFilter,
  [Types.SET_NORMALIZATION]: handleSetNormalization,
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [PortfolioRootTypes.SET_SELECTED_BASE]: handleSetSelectedBase,
}

export default createReducer(INITIAL_STATE, HANDLERS)
